import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { isMobile } from "react-device-detect";
import { useTranslation } from 'react-i18next';
import formatDate from '../../../../../../app/frontend/components/components/utils/formatDate';
import Price from '../../../../../frontend/components/components/utils/numbers/Price'
import './PendingPayment.scss';

function PendingPayment({ offer }) {
  const { t } = useTranslation();
  const extraPayments = offer.extra_payments;
  const rewards = offer.user_offer.reward_requests.filter(reward => reward.rtype == 'payment');

  return <div className="pending_payment">
    <Container>

      <Row>
        <Col>
          <h3>
            {t('influencers.pages.campaign.pending_payment.title')}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            {t('influencers.pages.campaign.pending_payment.text')}
          </div>
        </Col>
      </Row>

      <br />

      {rewards.map(reward =>
        <Row key={reward.id}>
          <Col className='col-md-4'>
            <h3>
              <Price number={reward.amount} currency={reward.currency}/>
            </h3>
            <div>
              {t('influencers.pages.campaign.pending_payment.amount')}
            </div>
          </Col>

          <Col className={`col-md-4 ${isMobile ? 'pendingPayment' : ''}`} >
            <h3>
              <div>
                {
                  reward.payment_request_due_at ?
                    formatDate(reward.payment_request_due_at, { format: 'L' })
                    : <div>
                      {
                        offer.user_offer.estimated_payment_date ?
                          formatDate(offer.user_offer.estimated_payment_date, { format: 'L' })
                          : ""
                      }
                    </div>
                }
              </div>
            </h3>
            <div>
              {t('influencers.pages.campaign.pending_payment.payout_day')}
              <br/>
              <div class="text-3">
                {t('influencers.pages.campaign.pending_payment.payout_disclaimer')}
              </div>
            </div>
          </Col>
        </Row>
      )}

      {
        extraPayments.map(payment =>
          <Row>
            <Col className='col-md-4'>
              <h3>
                <Price number={payment.amount} currency={payment.currency}/>
              </h3>
              <div>
                {t('influencers.pages.campaign.extra_pending_payment.amount')}
              </div>
            </Col>
          </Row>
        )

      }

      <br />

      <Row>
        <Col>
          <h3>
            {offer.paypal_email}
          </h3>
          <div>
            {t('influencers.pages.campaign.pending_payment.paypal_mail')}
          </div>
        </Col>
      </Row>

    </Container>
  </div>;
}

export default PendingPayment;
